import { useCallback } from "react";
import { AppRemixIcon } from "@/layout/AppComponents";
import { useDispatch } from "react-redux";
import axios from "axios";
import { axiosPath } from "../../../../routing/helpers/router";
import ErrorHandler from "../../../components/error/ErrorHandler";

const NewsletterFileButtons = (props) => {
  const { newsletterEntry } = props;
  const dispatch = useDispatch();

  const handleDownloadFile = useCallback(
    async () =>
      axios
        .post(axiosPath("api_r_user_module_newsletterManager_entry_download"), {
          newsletterEntryID: newsletterEntry.id,
        })
        .then((r) => {
          window.location = r.data;
        })
        .catch((e) => dispatch(ErrorHandler(e, history))),
    [newsletterEntry]
  );

  return (
    <span
      className="btn btn-xs btn-outline-success ml-2"
      title="Descargar excel"
      onClick={handleDownloadFile}
    >
      <AppRemixIcon icon="download-2" />
    </span>
  );
};

export default NewsletterFileButtons;
